export default __webpack_public_path__ + "static/media/0.d9b5f972.png";